import * as React from 'react';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { ISimilarOffer } from '../../api/similar';
import { isArrayWithItems } from '../../utils';
import * as styles from './index.css';
import { SimilarOfferItem } from './item';
import * as Analytics from '../../ebc/track_similar';
import { getVariants } from '../../utils/ebc';
import { TModelType } from '../../store/similar';

export interface IDataLayerEvent {
  eventAction: string;
  modelVersion: string;
}

export interface ISimilarOffersProps {
  title: string;
  agent: IAgentSchema | null;
  offer: IOfferSchema;
  similarOffers: ISimilarOffer[];
  withoutCompetitors: boolean | null;
  modelVersion: number | string | null;
  modelType: TModelType;
  user: Analytics.IUserEBC;
  page: Analytics.IPageEBC;

  requestSimilarOffers(offerId: number): void;
}

export function setMinHeight(elements: NodeListOf<Element>) {
  const images = (document.querySelector(`.${styles['image_link']} img`) as HTMLImageElement);

  if (images) {
    const imagesHeight = images.offsetHeight;

    Array.prototype.forEach.call(elements, (noneImage: HTMLDivElement) => {
      noneImage.style.minHeight = `${imagesHeight}px`;
    });
  }
}

export class SimilarOffers extends React.Component<ISimilarOffersProps, {}> {
  private container: HTMLElement | null;
  private productsEbc: Analytics.TProductPartial[] = [];

  public componentDidMount() {
    const {
      offer,
      requestSimilarOffers,
    } = this.props;
    requestSimilarOffers(offer.cianId);
    window.addEventListener('scroll', this.handleShowOffers);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: ISimilarOffersProps) {
    if (!isArrayWithItems<ISimilarOffer>(this.props.similarOffers) &&
      isArrayWithItems<ISimilarOffer>(nextProps.similarOffers)) {

      // Ресайзим высоту заглушки, когда нет картинки
      if (nextProps.similarOffers.some(similarOffer => !similarOffer.photoUrl || similarOffer.photoUrl.length === 0)) {
        const noneImages = document.querySelectorAll(`.${styles['none_image']}`);

        setMinHeight(noneImages);

        window.addEventListener('resize', () => setMinHeight(noneImages));
      }

      if (nextProps.similarOffers.length) {
        this.productsEbc = nextProps.similarOffers.map((similarOffer, index): Analytics.TProductPartial => {
          let variant;

          if (similarOffer.variant) {
            variant = getVariants(similarOffer.variant);
          }

          return {
            id: similarOffer.id || undefined,
            position: index + 1,
            ownerId: similarOffer.publishedUserId || undefined,
            variant,
          };
        });
      }
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShowOffers);
  }

  public render() {
    const {
      title,
      similarOffers,
    } = this.props;

    if (!isArrayWithItems<ISimilarOffer>(similarOffers)) {
      return <div className={styles['empty']} ref={container => this.container = container}/>;
    }

    return (
      <section className={styles['container']} ref={container => this.container = container}>
        <h2 className={styles['title_block']}>
        { title }
        </h2>
        <ul className={styles['list']}>
          {similarOffers.map((similarOffer, index) =>
            <SimilarOfferItem
              key={`similarOffer_${index}`}
              offer={similarOffer}
              onClick={this.handleClickOffer}
              position={index + 1}
            />)}
        </ul>
      </section>
    );
  }

  private handleShowOffers = () => {
    const { modelVersion: propsModelVersion, withoutCompetitors, user, page } = this.props;
    const modelVersion = propsModelVersion ? String(propsModelVersion) : '0';

    const eventAction = withoutCompetitors
      ? Analytics.EtrackOffersShowActions.show_others_offers
      : Analytics.EtrackOffersShowActions.show_similar_offers;

    if (
      // tslint:disable:no-any
      (window as any).dataLayer &&
      !(window as any).dataLayer.find((event: IDataLayerEvent) =>
      // tslint:enable:no-any
        event.eventAction === eventAction && event.modelVersion === modelVersion)
    ) {
      // tslint:disable-next-line:no-non-null-assertion
      const containerPositionMiddle = this.container!.offsetTop + (this.container!.offsetHeight / 2);
      const windowScrollPosition = window.pageYOffset + window.innerHeight;

      if (windowScrollPosition > containerPositionMiddle) {
        window.removeEventListener('scroll', this.handleShowOffers);

        Analytics.trackOffersShow({
          action: eventAction,
          products: this.productsEbc,
          modelVersion,
          user,
          page,
        });
      }
    }
  }

  private handleClickOffer = (curOffer: ISimilarOffer, position: number) => {
    const { agent, offer, withoutCompetitors, modelVersion: propsModelVersion, user, page } = this.props;
    const products: Analytics.TProductPartial[] = [{
      id: curOffer.id || undefined,
      position,
      ownerId: curOffer.publishedUserId || undefined,
      variant: curOffer.variant ? getVariants(curOffer.variant) : [],
    }];
    const modelVersion = String(propsModelVersion || 0);

    Analytics.trackOfferClick({
      action: withoutCompetitors
            ? Analytics.EtrackOfferClicksActions.click_others_offers
            : Analytics.EtrackOfferClicksActions.click_similar_offers,
      products,
      agent,
      offer,
      modelVersion,
      user,
      page,
    });
  }
}
